enum SpreadTypes {
  daily = "daily",
  pastPresentFuture = "pastPresentFuture",
  thinkFeelDo = "thinkFeelDo",
}

enum SpreadLayouts {
  line = "line",
  pyramid = "pyramid",
  cross = "cross",
}

export const SPREADS: ISpreadMetadata[] = [
  {
    id: 1,
    type: SpreadTypes.daily,
    title: "Daily Card",
    description: "For reflection on your day",
    totalCards: 1,
    layout: SpreadLayouts.line,
    positions: [
      {
        title: "Your Daily Card",
        index: 1,
      },
    ],
  },
  {
    id: 2,
    type: SpreadTypes.pastPresentFuture,
    title: "S.O.S",
    description: "For quick situation analyzing",
    totalCards: 3,
    layout: SpreadLayouts.line,
    positions: [
      {
        title: "Supporting / Blocking",
        index: 1,
        introDuration: "1000",
      },
      {
        title: "Answer",
        index: 2,
        introDuration: "500",
      },
      {
        title: "Supporting / Blocking",
        index: 3,
        introDuration: "1500",
      },
    ],
  },
  {
    id: 3,
    type: SpreadTypes.pastPresentFuture,
    title: "Past, Present, Future",
    description: "For evaluating a situation",
    totalCards: 3,
    layout: SpreadLayouts.line,
    positions: [
      {
        title: "Past",
        index: 1,
        introDuration: "1000",
      },
      {
        title: "Present",
        index: 2,
        introDuration: "500",
      },
      {
        title: "Future",
        index: 3,
        introDuration: "1500",
      },
    ],
  },
  {
    id: 4,
    type: SpreadTypes.thinkFeelDo,
    title: "Think, Feel, Do",
    description: "For reflecting your thoughts",
    totalCards: 3,
    layout: SpreadLayouts.line,
    positions: [
      {
        title: "What I Think",
        index: 1,
        introDuration: "1000",
      },
      {
        title: "How I Feel",
        index: 2,
        introDuration: "500",
      },
      {
        title: "What to Do",
        index: 3,
        introDuration: "1500",
      },
    ],
  },
];
